import { ApolloClient, HttpLink, ApolloLink, InMemoryCache, concat } from '@apollo/client';
import ApolloLinkTimeout from "apollo-link-timeout";
import { fetchAuthSession } from 'aws-amplify/auth';

const timeoutLink = new ApolloLinkTimeout(30000);

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPHQL_ADMIN_API_URL });
const timeoutHttpLink = timeoutLink.concat(httpLink);

const httpUnauthLink = new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL_API_UNAUTH_URL,
});
const timeoutHttpUnauthLink = timeoutLink.concat(httpUnauthLink);

const authMiddleware = new ApolloLink(async (operation, forward) => {
    const session = await fetchAuthSession();
    const token = session?.tokens?.idToken;
    if (token) {
        operation.setContext({
            headers: {
                authorization: token,
                "Accept-Language": localStorage.getItem("language") || "en",
            },
        });
    }
    return forward(operation);
});

const link = ApolloLink.split(
    (operation) => {
        // console.log("operation.getContext()====>", operation.getContext());
        return operation.getContext().hasOwnProperty("unauth");
    },
    timeoutHttpUnauthLink,
    concat(authMiddleware, timeoutHttpLink)
);

const client = new ApolloClient({
    link: link,
    cache: new InMemoryCache(),
});

export { client };
